export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Operation wiederholen"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Operationsgeschichte"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kontenliste"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unbekannter Fehler"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tokenliste"])}
}